export enum SamGongWinners {
	player,
	banker,
	tie
}

//Gets SamGong card value
function getSGCardValue(cardStr: string) {
	return "TJQK".indexOf(cardStr[0]) >= 0 ? 10 : Number(cardStr[0]);
}

/*
Test cases:
Player vs Banker
AAA vs QQQ --> Player wins

JJJ vs QQQ --> Banker wins

JQK vs 10JJ --> Player wins

987 vs 765 --> 24 vs 18 --> 4 vs 8 --> Banker wins

QQ7 vs 124 --> 7 vs 7 --> 27 vs 7 --> Player wins

28J vs 234 --> 20 vs 9 --> 10 vs 9 --> Player wins
*/

function getSamGongText(cardSetStr: string): string {
	const splitStr = cardSetStr.split(",");

	if (splitStr.some(card => card === "x"))
		return "0";

	// Check for higher ranks first
	switch (splitStr.map(card => card[0]).join("")) {
		case "111": return "3A";
		case "KKK":
		case "QQQ":
		case "JJJ": return "3P";
		default: break;
	}

	// Check for All Pictures
	if (splitStr.filter(card =>
		card[0] !== "T" && //Ten
		isNaN(Number(card[0]))
	).length === 3)
		return "AP";

	const cardSetValue = getSamGongValue(cardSetStr);

	return (cardSetValue % 10 === 0 ? 10 :
		cardSetValue % 10) + "";
}

//Gets SamGong value for roadmap & SamGong virtual balls
function getSamGongValue(cardSetStr: string): number {
	return cardSetStr.split(",")
		.map(card => getSGCardValue(card[0]))
		.reduce((a, b) => a + b);
}

// SamGong special values (only for comparison & rank system, not the real rank)
const SamGongRanks = {
	"111": 100,
	"KKK": 80,
	"QQQ": 60,
	"JJJ": 40
};

function newSamGongResultComparisonTest() {
	console.log(
		"Player vs Banker | program output | expected output\n" +
		"AAA:QQQ --> "  + SamGongWinners[compareSamGongResult("1b,1c,1d", "Qb,Qc,Qd")] + " (player)\n" +
		"JJJ:QQQ --> "  + SamGongWinners[compareSamGongResult("Jb,Jc,Jd", "Qb,Qc,Qd")] + " (banker)\n" +
		"JQK:10JJ --> " + SamGongWinners[compareSamGongResult("Jb,Qc,Kd", "Tb,Jc,Jd")] + " (player)\n" +
		"QQ7:124 --> "  + SamGongWinners[compareSamGongResult("Qb,Qc,7d", "1b,2c,4d")] + " (player)\n" +
		"28J:234 --> "  + SamGongWinners[compareSamGongResult("2b,8c,Jd", "2b,3c,4d")] + " (player)\n" +

		"987:765 --> "  + SamGongWinners[compareSamGongResult("9b,8c,7d", "7b,6c,5d")] + " (banker)\n" +
		"J109:KQ9 --> " + SamGongWinners[compareSamGongResult("Jb,Tc,9d", "Kb,Qc,9d")] + " (banker)\n"
	);
}

function compareSamGongResult(player: string, banker: string): SamGongWinners {
	const playerSplit = player.split(",");
	const bankerSplit = banker.split(",");

	const playerTriple = playerSplit.map(card => card[0]).join("");
	const bankerTriple = bankerSplit.map(card => card[0]).join("");


	let playerValue = -1, bankerValue = -1;

	const playerPicCount = playerTriple.split("").filter(card => isNaN(+card) && card !== "T").length;
	const bankerPicCount = bankerTriple.split("").filter(card => isNaN(+card) && card !== "T").length;

	const playerHasRank = (playerTriple in SamGongRanks);
	const bankerHasRank = (playerTriple in SamGongRanks);

	const player3Pic = playerPicCount === 3;
	const banker3Pic = bankerPicCount === 3;

	//Get Rank value
	if (playerHasRank)
		playerValue = SamGongRanks[playerTriple];
	else if (player3Pic)
		playerValue = 35;
	else playerValue = getSamGongValue(player);
	
	if (bankerHasRank)
		bankerValue = SamGongRanks[bankerTriple];
	else if (banker3Pic)
		bankerValue = 35;
	else bankerValue = getSamGongValue(banker);

	//To debug parameters
	// "cards: total card value (picture count)" +
	// console.log(
	// 	playerTriple + ": " + playerValue + "(" + playerPicCount + ")",
	// 	bankerTriple + ": " + bankerValue + "(" + bankerPicCount + ")"
	// );

	const playerSpecial = playerHasRank || player3Pic;
	const bankerSpecial = bankerHasRank || banker3Pic;

	// Compare picture count
	if (!playerSpecial)
		playerValue %= 10;
		if (playerValue === 0)
			playerValue = 10;
	
	if (!bankerSpecial)
		bankerValue %= 10;
		if (bankerValue === 0)
			bankerValue = 10;

	// Ignore this if player/banker isn't in tie & don't have special ranks or 3 pictures
	if (!(playerSpecial && bankerSpecial) &&
		playerValue % 10 === bankerValue % 10)
		return (playerPicCount > bankerPicCount) ?
			SamGongWinners.player : SamGongWinners.banker;

	return (playerValue === bankerValue) ?
			SamGongWinners.tie :
		(playerValue > bankerValue) ?
			SamGongWinners.player :
			SamGongWinners.banker;
}

export {
	// Functions
	getSamGongText, getSamGongValue, newSamGongResultComparisonTest, compareSamGongResult,
};
